export let RECORDER_STATES = /** @type {const} */ ({
  INITIAL: 'INITIAL',
  STARTING: 'STARTING',
  RECORDING: 'RECORDING',
  PAUSED: 'PAUSED',
  ENCODING: 'ENCODING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
})
